import React from 'react';
import s from './RectangularTabInner.scss';

const RectangularTabInner = ({
  title,
  className,
  subtitle,
  classes,
  desc,
  value,
  unit,
  isbackgroundNeeded,
}) => (
  <div
    className={`${s.details_box} ${isbackgroundNeeded ? s.details_box_2 : ''} ${
      s[classes]
    }`}
  >
    <div className={s.details}>
      <div>
        <h4>{title}</h4>
        <p>{subtitle}</p>
      </div>
      {value &&
        unit && (
          <div>
            <h4>{value}</h4>
            <p>{unit}</p>
          </div>
        )}
    </div>
    {className && <div className={s.info}>{desc}</div>}
  </div>
);

export default RectangularTabInner;
